module.exports = __webpack_public_path__ + "static/img/shop.5dec558.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shop.png
// module id = 258
// module chunks = 1